import { Navigate } from 'react-router-dom';

interface PageRedirectProps {
	url: string;
}

export const PageRedirect = ({ url }: PageRedirectProps): React.JSX.Element => (
	<Navigate to={url} replace />
);
